import { render, staticRenderFns } from "./pddBatchModifyPrices.vue?vue&type=template&id=5bf32757&scoped=true&"
import script from "./pddBatchModifyPrices.vue?vue&type=script&lang=js&"
export * from "./pddBatchModifyPrices.vue?vue&type=script&lang=js&"
import style0 from "./pddBatchModifyPrices.vue?vue&type=style&index=0&id=5bf32757&prod&lang=stylus&scoped=true&"
import style1 from "./pddBatchModifyPrices.vue?vue&type=style&index=1&id=5bf32757&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf32757",
  null
  
)

export default component.exports